/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { SearchIcon } from '../../../../assets/icons';
import { Constants, getUpdatedState } from '../../../../utils';
import { Input, Pagination, Select } from '../../../../components';
import { UserService } from '../../../../services';
import { DownloadIcon } from '../../../../assets/icons';
import { fromStorage } from '../../../../utils';

const Drivers = () => {
  const { data, filters, goToPage, downloadAll, downloadOne, onChange, pagination, reload, search, selects } = useFetchTable();

  return (
    <main className="w-full">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Buscar por conductor, CI"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            placeholder="Placa del vehículo"
            value={filters.plaque}
            onValueChange={v => onChange('plaque', v)}
          />

          <Input
            placeholder="Propietario"
            value={filters.owner}
            onValueChange={v => onChange('owner', v)}
          />

          <Select
            placeholder="Asignación de ruta"
            items={selects.assignments}
            value={filters.assignment}
            onValueChange={v => onChange('assignment', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md mt-6 w-full">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Registro de Conductores</p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th className="!pl-4">Nombre del conductor</th>
                <th>C.I.</th>
                <th>Correo</th>
                <th>Teléfono</th>
                <th>Dirección</th>
                <th>Placa</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Tipo de vehículo</th>
                <th>Propietario de vehículo</th>
                <th>Asignación de ruta</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <div className="pl-4">{item.person?.name}</div>
                  </td>
                  <td>{item.person?.document}</td>
                  <td title={item.email}>{item.email}</td>
                  <td>{item.person?.phone}</td>
                  <td title={item.person?.address_house}>{item.person?.address_house}</td>
                  <td>{item.person?.driver?.vehicle?.plaque}</td>
                  <td>{item.person?.driver?.vehicle?.brand}</td>
                  <td>{item.person?.driver?.vehicle?.model}</td>
                  <td>{item.person?.driver?.vehicle?.vehicle_types_sep?.map(x => x?.vehicle_type?.name)?.join(', ')}</td>
                  <td>{item.person?.driver?.vehicle?.owner?.person?.name || 'Maxer'}</td>
                  <td className="data-[status=1]:text-green font-semibold" data-status={item.is_available}>
                    {item.is_available ? 'Disponible' : 'No disponible'}
                  </td>
                  <td align="right">
                    <div className="pr-3">
                      <img
                        src={DownloadIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => {
                          toast.promise(
                            downloadOne(item?.id),
                            {
                              loading: 'Descargando...',
                              success: 'Reporte impreso con éxito',
                              error: 'Error al imprimir el reporte',
                            }
                          );
                        }}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    plaque: '',
    owner: '',
    assignment: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects] = useState({
    assignments: [
      { value: 0, label: 'No disponible' },
      { value: 1, label: 'Disponible' },
    ],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await UserService.moderator.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await UserService.moderator.downloadAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadOne = async (id) => {
    try {
      const response = await UserService.moderator.downloadOne(id);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    downloadAll,
    downloadOne,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
  }
}

export default Drivers;